import { render, staticRenderFns } from "./ExploreCourseItem.vue?vue&type=template&id=85e2c610&scoped=true&"
import script from "./ExploreCourseItem.vue?vue&type=script&lang=js&"
export * from "./ExploreCourseItem.vue?vue&type=script&lang=js&"
import style0 from "./ExploreCourseItem.vue?vue&type=style&index=0&id=85e2c610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e2c610",
  null
  
)

export default component.exports